export default class AuthorizationService {
    static getUserRole() {
        const roles = JSON.parse(localStorage.getItem('roles')) || {};
        const prestador = JSON.parse(localStorage.getItem('idPrestador'));

        if (roles.admin) return 'ADMIN';
        if (roles.superAdmin) return 'ADMIN';
        if (roles.isEmpresaAdm) return 'ADMIN_EMPRESA';
        if (prestador) return 'PRESTADOR';
        return 'USER';
    }

    static getResourceAccessLevel(resourceName) {
        const role = this.getUserRole();
        const accessMap = {
            'config': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'agendamento': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'agendamento-tipo': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'agenda': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'empresa': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'empresa-categoria': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'endereco': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'financeiro': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'image': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'prestador': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'prestador-tipo': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'prestador-tipo-agendamento': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'perfil': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'NONE'
            },
            'usuario': {
                'ADMIN': 'GLOBAL',
                'ADMIN_EMPRESA': 'COMPANY',
                'PRESTADOR': 'SELF',
                'USER': 'SELF'
            },
            // Adicione outros recursos conforme necessário
        };

        return accessMap[resourceName]?.[role] || 'NONE';
    }

    static hasPermission(permission) {
        const roles = JSON.parse(localStorage.getItem('roles')) || {};
        return !!roles[permission];
    }
}